<template>
  <div id="modalCreateAttachment" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cadastrar Anexo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.attachment.name.$errors.length }"
                  placeholder="Nome do Anexo"
                  v-model="v$.attachment.name.$model"
                />
                <span
                  v-if="v$.attachment.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.attachment.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.attachment.name.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Tipo de Anexo: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.attachment.type.$errors.length }"
                  v-model="v$.attachment.type.$model"
                >
                  <option value="">Selecione o tipo do Anexo</option>
                  <option value="1">Arquivo Local</option>
                  <option value="2">Link Externo</option>
                </select>
                <span
                  v-if="v$.attachment.type.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div v-if="attachment.type == 1" class="col-sm-12">
                <label class="form-label">
                  Arquivo: <span class="text-danger">*</span>
                </label>
                <input
                  type="file"
                  class="form-control h-auto"
                  @change="handleFileUploads"
                  ref="file"
                />
              </div>
              <div v-if="attachment.type == 2" class="col-sm-12">
                <label class="form-label">
                  Link: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.attachment.link.$errors.length }"
                  placeholder="Link do Anexo"
                  v-model="v$.attachment.link.$model"
                />
                <span
                  v-if="v$.attachment.link.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.attachment.link.url.$invalid"
                  class="invalid-feedback"
                >
                  Formato de URL inválido
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Cadastrar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Cadastrar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, requiredIf, url } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateAttachmentModal',

  props: {
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
    lessonId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      attachment: {
        name: '',
        type: '',
        link: '',
      },
      file: null,
      disableButton: false,
    }
  },

  methods: {
    handleFileUploads() {
      const { files } = this.$refs.file
      const [file] = files
      this.file = file
    },

    async save() {
      if (!this.v$.$invalid) {
        if (this.attachment.type === '1' && this.file === null) {
          this.$root.$refs.notification.warning(
            'Selecione um arquivo antes de continuar',
          )
          return
        }

        this.disableButton = true
        try {
          const formData = new FormData()
          formData.append('attachment', JSON.stringify(this.attachment))
          formData.append('file', this.file)

          const response = await this.$store.dispatch('saveAttachment', {
            courseId: this.courseId,
            moduleId: this.moduleId,
            lessonId: this.lessonId,
            attachment: formData,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      attachment: {
        name: {
          required,
          minLength: minLength(4),
        },
        type: {
          required,
        },
        link: {
          required: requiredIf(() => {
            return this.attachment.type === '2'
          }),
          url,
        },
      },
    }
  },

  mounted() {
    showModal('modalCreateAttachment')
  },
}
</script>
